import { h, Fragment } from 'preact';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Pagination ,Navigation} from 'swiper';
import { useEffect, useMemo, useRef } from 'preact/hooks';
import Media from 'utils/media';
import ArrowIcon from 'utils/icon/icon-arrow.svg';

const ProductGalleryMobile = ({ currentProduct }) => {
  if (!currentProduct) return null;
  const { media } = currentProduct;
  const slider = useRef(null);

  const paginationConfig = useMemo(
    () => ({
      clickable: false,
      horizontalClass: 'mx-[18px] bg-[#dcdad4] h-[2px] mt-[11px] !flex !static !w-[calc(100%-36px)]',
      bulletClass: 'h-full flex-grow',
      bulletActiveClass: 'bg-black',
    }), []);

  const handleClick = (index) => {
    const body = document.querySelector('body');
    if (index != null) {
      body.classList.add('overflow-hidden');
    } else {
      body.classList.remove('overflow-hidden');
    }
  };

  const setVideoThumbnailVisibility = ( visibility ) => {
    const videoThumbnail = document.querySelector('[data-target="slider-video-button"]');
    if (!videoThumbnail) return;
    if (visibility) videoThumbnail.classList.remove('hidden');
    else videoThumbnail.classList.add('hidden');
  }

  const sliderToVideo = () => {
    slider.current.slideTo(slider.current.slides.length - 2);
  };

  useEffect(() => {
    if (slider.current) {
      if (media?.length > 1) {
        slider.current.enable();
        slider.current.slideTo(1);
        slider.current.pagination.enable();
      } else {
        slider.current.disable();
        slider.current.pagination.disable();
      }
    }
  }, [media]);

  return (
    <>
      <div className="w-full overflow-hidden relative">
        <Swiper
          modules={[Pagination, FreeMode, Navigation]}
          loop={true}
          freeMode={false}
          pagination={paginationConfig}
          onInit={(swiper) => {
            slider.current = swiper;
          }}
          onSlideChange={(swiper) => {
            setVideoThumbnailVisibility(swiper.realIndex !==
              (swiper.slides.length - 3));
            }
          }
        >
          {media?.length > 0 && media.map((item, index) => (
            <SwiperSlide key={item.id}>
              <div key={item.previewImage.id} className="relative pb-[100%] aaaa">
                <Media
                  {...item}
                  onClick={() => handleClick(index)}
                  className="absolute inset-0 object-cover h-full w-full"
                  controlClass="text-black bg-white !opacity-100"
                  lazyLoad={index !== 0}
                  srcWidths={{
                    sm: 640,
                    md: 768,
                    lg: 1024,
                    xl: 1280,
                    '2xl': 1536,
                  }}
                />
              </div>
            </SwiperSlide>
          ))}

          <button type="button" className='hidden text-black bg-white absolute h-10 w-10  p-2 rotate-180 left-5 inset-y-2/4 z-10 rounded-full drop-shadow-md md:flex items-center justify-center' onClick={() => slider.current.slidePrev()}>
            <span className='sr-only'>Previous slide</span>
            <ArrowIcon />
          </button>
          <button type="button" className='hidden text-black bg-white absolute h-10 w-10 p-2 right-5 inset-y-2/4 z-10 rounded-full drop-shadow-md md:flex items-center justify-center' onClick={() => slider.current.slideNext()}>
            <span className='sr-only'>Next slide</span>
            <ArrowIcon />
          </button>
        </Swiper>
        {media?.length > 0 && media[media.length - 1]?.mediaContentType === 'VIDEO' && (
          <div className="absolute w-[35px] h-[35px] right-2 top-[calc(100vw-44px)] z-10" data-target="slider-video-button">
            <Media
              {...media[media.length - 1]}
              onClick={() => sliderToVideo()}
              className="absolute inset-0 object-cover h-full w-full"
              parentClass="h-full w-full"
              controlClass="pointer-events-none !opacity-100 !left-[3px] !top-[3px] z-10 absolute w-7 h-7 rounded-full flex items-center justify-center "
              justPlayButton="true"
              srcWidths={{
                sm: 640,
                md: 768,
                lg: 1024,
                xl: 1280,
                '2xl': 1536,
              }}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default ProductGalleryMobile;
